import React, { useState } from "react";
import { Link } from "react-router-dom";
import {  FaTools, FaRocket, FaHandshake, FaUserTie } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import styled from "styled-components";

// Styles simplifiés
const FAQContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: white;
  padding: 30px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  
  @media (min-width: 992px) {
    flex-direction: row;
    gap: 40px;
  }
`;

const FAQContent = styled.div`
  flex: 1;
`;

const FAQItem = styled.div`
  background: #ffffff;
  margin: 15px 0;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  
  &:hover {
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
  }
`;

const Question = styled.div`
  background: #f9fafb;
  padding: 18px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
  border-radius: 8px;

  &:hover {
    background: #eef1f6;
    color: #E60000;
  }
`;

const Answer = styled.div`
  padding: 20px;
  font-size: 16px;
  line-height: 1.6;
  color: #555;
  background: #ffffff;
  border-top: 1px solid #eaeaea;
`;

const Icon = styled.span`
  font-size: 22px;
  font-weight: bold;
  color: #E60000;
  transition: transform 0.3s ease;
  ${({ isOpen }) => isOpen && "transform: rotate(180deg);"}
`;

const ServiceCard = styled.div`
  background: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 100%;
  margin-bottom: 20px;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  }
`;

const StepCard = styled.div`
  background: white;
  border-radius: 10px;
  padding: 30px;
  margin-bottom: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 100%;
    background: linear-gradient(to bottom, #228B22, #E60000);
  }
`;

const StepNumber = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  background: linear-gradient(135deg, #228B22, #E60000);
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 20px;
`;

const WhyChooseItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 25px;
`;

const WhyChooseIcon = styled.div`
  background: linear-gradient(135deg, #228B22, #E60000);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  margin-right: 20px;
  flex-shrink: 0;
`;

const CallToAction = styled.div`
  background: linear-gradient(135deg, rgba(34, 139, 34, 0.9), rgba(230, 0, 0, 0.9));
  padding: 60px 0;
  color: white;
  text-align: center;
  border-radius: 10px;
  margin: 60px 0;
`;

const CTAButton = styled.button`
  background: white;
  color: #E60000;
  border: none;
  padding: 12px 30px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: #f8f8f8;
    transform: scale(1.05);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
`;

const BusinessCreation = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqData = [
    { 
      question: "Pourquoi se faire accompagner pour la création ou la transformation de mon entreprise ?", 
      answer: "L'accompagnement d'un expert-comptable sécurise vos démarches, optimise vos choix stratégiques, et vous évite les erreurs coûteuses. Il vous permet de démarrer ou de faire évoluer votre activité sur des bases solides."
    },
    { 
      question: "À qui s'adresse ce service ?", 
      answer: "Il s'adresse aux porteurs de projets, aux créateurs d'entreprise, aux entrepreneurs souhaitant transformer leur activité (restructuration, cession, etc.), et aux entreprises en développement."
    },
    { 
      question: "Quels sont les avantages de passer par un expert-comptable pour ces démarches ?", 
      answer: "L'expert-comptable apporte une vision globale (comptable, fiscale, juridique), une expertise technique, et un réseau de partenaires (avocats, notaires, banquiers). Il garantit la conformité de vos démarches et vous conseille de manière personnalisée."
    },
    { 
      question: "Quels services proposez-vous pour la création d'entreprise ?", 
      answer: "Nous proposons : l'étude de faisabilité du projet (business plan, prévisionnel financier), le choix de la forme juridique et du régime fiscal, la rédaction des statuts, les démarches d'immatriculation, l'accompagnement pour l'obtention de financements, et la mise en place des outils de gestion."
    }
  ];

  const creationSteps = [
    {
      title: "Étude de marché et business plan",
      description: "Validation de votre idée, définition de votre stratégie et élaboration d'un business plan solide."
    },
    {
      title: "Choix de la forme juridique",
      description: "SA, SARL, SAS, SASU, entreprise individuelle… Nous vous conseillons sur la structure la plus adaptée à votre projet et à vos objectifs."
    },
    {
      title: "Formalités administratives et juridiques",
      description: "Immatriculation, rédaction des statuts, obtention des autorisations nécessaires… Nous prenons en charge l'ensemble des démarches."
    },
    {
      title: "Financement",
      description: "Recherche de financements (prêts bancaires, aides publiques, levée de fonds…), préparation de votre dossier de financement."
    },
    {
      title: "Premiers pas de l'entrepreneur",
      description: "Conseils pratiques pour démarrer sereinement votre activité (comptabilité, gestion, fiscalité)."
    }
  ];

  const transformationSteps = [
    {
      title: "Diagnostic stratégique",
      description: "Analyse de votre situation actuelle, identification des axes d'amélioration et des opportunités de croissance."
    },
    {
      title: "Restructuration juridique et financière",
      description: "Optimisation de votre structure juridique et financière pour répondre à vos nouveaux enjeux."
    },
    {
      title: "Accompagnement au changement",
      description: "Gestion de la transition, communication interne, formation des équipes."
    },
    {
      title: "Développement commercial et marketing",
      description: "Définition et mise en œuvre de stratégies pour conquérir de nouveaux marchés et fidéliser vos clients."
    },
    {
      title: "Transmission d'entreprise",
      description: "Préparation et accompagnement dans la cession ou la reprise d'entreprise."
    }
  ];

  const whyChooseUs = [
    {
      icon: <FaUserTie />,
      title: "Expertise pluridisciplinaire",
      description: "Nos consultants disposent d'une solide expertise en comptabilité, finance, droit, fiscalité et stratégie d'entreprise."
    },
    {
      icon: <FaTools />,
      title: "Approche personnalisée",
      description: "Nous adaptons notre accompagnement à vos besoins spécifiques et à votre secteur d'activité."
    },
    {
      icon: <FaHandshake />,
      title: "Suivi régulier",
      description: "Nous sommes à vos côtés à chaque étape de votre projet, pour vous apporter un soutien continu et réactif."
    },
    {
      icon: <FaRocket />,
      title: "Proximité",
      description: "Nous privilégions une relation de confiance et de proximité avec nos clients."
    }
  ];

  return (
    <>
      <Header />

      {/* Banner Section */}
      <section className="service-banner d-flex align-items-center">
        <div className="container text-white text-start">
          <h1 className="fw-bold mb-4">Accompagnement à la Création et Transformation d'Entreprise</h1>
          <p className="lead mb-4">Vous avez une idée innovante ? Vous souhaitez faire évoluer votre entreprise existante ? Découvrez notre accompagnement sur mesure.</p>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/" className="text-white text-decoration-none">
                  Accueil
                </Link>{" "}
                /{" "}
                <Link to="/services" className="text-white text-decoration-none">
                  Services
                </Link>
              </li>
              <li className="breadcrumb-item active text-white" aria-current="page">
                Accompagnement Entrepreneurial
              </li>
            </ol>
          </nav>
        </div>
      </section>

      {/* Intro Section */}
      <section className="service-intro py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h2 className="fw-bold mb-4">Votre Partenaire dans la Réussite Entrepreneuriale</h2>
              <p className="lead text-muted">
                A CINEF-EC, nous comprenons que la création et la transformation d'entreprise sont des étapes cruciales, souvent complexes. C'est pourquoi nous avons développé un service d'accompagnement complet, conçu pour vous apporter le soutien et l'expertise dont vous avez besoin.
              </p>
              <p className="text-muted">
                Nous transformons vos idées en entreprises prospères, en vous offrant un accompagnement 
                stratégique complet, de la conception initiale à la croissance durable. Notre expertise vous guide à travers chaque étape cruciale de votre parcours entrepreneurial, 
                en minimisant les risques et en maximisant vos opportunités de succès.
              </p>
              <CTAButton className="mt-4">Prendre rendez-vous</CTAButton>
            </div>
            <div className="col-lg-6">
              <img 
                src="/assets/images/image14.png" 
                alt="Équipe entrepreneuriale en consultation" 
                className="img-fluid rounded shadow-lg"
                style={{ width: '100%', height: 'auto' }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="bg-light py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">Nos Services d'Accompagnement</h2>
            <p className="text-muted">Une approche complète pour concrétiser vos ambitions entrepreneuriales</p>
          </div>

          <div className="mb-5">
            <div className="row">
              <div className="col-12 mb-4">
                <h3 className="fw-bold">Création d'entreprise</h3>
              </div>
              {creationSteps.map((step, index) => (
                <div className="col-md-6" key={`creation-${index}`}>
                  <StepCard>
                    <StepNumber>{index + 1}</StepNumber>
                    <h4 className="fw-bold mb-3">{step.title}</h4>
                    <p className="text-muted">{step.description}</p>
                  </StepCard>
                </div>
              ))}
            </div>
          </div>

          <div className="row">
            <div className="col-12 mb-4">
              <h3 className="fw-bold">Transformation et Développement d'entreprise</h3>
            </div>
            {transformationSteps.map((step, index) => (
              <div className="col-md-6" key={`transformation-${index}`}>
                <StepCard>
                  <StepNumber>{index + 1}</StepNumber>
                  <h4 className="fw-bold mb-3">{step.title}</h4>
                  <p className="text-muted">{step.description}</p>
                </StepCard>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}

      {/* Why Choose Us */}
      <section className="py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">Pourquoi choisir CINEF-EC ?</h2>
            <p className="text-muted">Découvrez les avantages de notre accompagnement</p>
          </div>

          <div className="row">
            {whyChooseUs.map((item, index) => (
              <div className="col-md-6" key={index}>
                <WhyChooseItem>
                  <WhyChooseIcon>
                    {item.icon}
                  </WhyChooseIcon>
                  <div>
                    <h4 className="fw-bold mb-2">{item.title}</h4>
                    <p className="text-muted">{item.description}</p>
                  </div>
                </WhyChooseItem>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq-section" className="container-fluid py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">Questions Fréquentes</h2>
            <p className="text-muted">Tout ce que vous devez savoir sur notre accompagnement entrepreneurial</p>
          </div>
          
          <FAQContainer>
            <FAQContent>
              {faqData.map((faq, index) => (
                <FAQItem key={index}>
                  <Question onClick={() => toggleFAQ(index)}>
                    {faq.question}
                    <Icon isOpen={activeIndex === index}>{activeIndex === index ? "−" : "+"}</Icon>
                  </Question>
                  {activeIndex === index && <Answer>{faq.answer}</Answer>}
                </FAQItem>
              ))}
            </FAQContent>
          </FAQContainer>
        </div>
      </section>

      <Footer />

      <style>{`
        .service-banner {
          background: linear-gradient(to right, rgba(0, 138, 68, 0.85), rgba(220, 53, 69, 0.85)), url("/assets/images/service-banner.jpg");
          background-size: cover;
          background-position: center;
          height: 400px;
          display: flex;
          align-items: center;
        }
        
        .lead {
          font-size: 1.25rem;
          font-weight: 300;
          line-height: 1.5;
        }
      `}</style>
    </>
  );
};

export default BusinessCreation;